var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30891 14.6178C3.2722 14.6178 0 11.3456 0 7.30891C0 3.2722 3.2722 0 7.30891 0C11.3456 0 14.6178 3.2722 14.6178 7.30891C14.6178 11.3456 11.3456 14.6178 7.30891 14.6178ZM7.30891 13.7407C9.01474 13.7407 10.6507 13.0631 11.8569 11.8569C13.0631 10.6507 13.7407 9.01474 13.7407 7.30891C13.7407 5.60308 13.0631 3.96711 11.8569 2.76091C10.6507 1.55471 9.01474 0.877069 7.30891 0.877069C5.60308 0.877069 3.96711 1.55471 2.76091 2.76091C1.55471 3.96711 0.877069 5.60308 0.877069 7.30891C0.877069 9.01474 1.55471 10.6507 2.76091 11.8569C3.96711 13.0631 5.60308 13.7407 7.30891 13.7407ZM6.4523 9.17853L10.698 4.93351L11.3178 5.55404L6.96904 9.90284C6.83198 10.0399 6.64611 10.1168 6.4523 10.1168C6.2585 10.1168 6.07263 10.0399 5.93556 9.90284L3.65445 7.62027L4.27498 6.99974L6.45303 9.1778L6.4523 9.17853Z",
    fill: "#3385F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.900bf7fdbf46bb4114a266ce94ff3f08.svg";
export { ForwardRef as ReactComponent };